import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import axios from "axios";
import BASE_URL from "../../BaseUrl";
import "../../styles/admin/AdminAssistantPage.css";
import { GlobalContext } from "../GlobalContext";
export default function AdminAssistantPage({active, setActive}){
    const [assistant,setAssistant] = useState(null);
    const {id} = useParams()
    const {admin, setAdmin} = useContext(GlobalContext);
    const [loaded, setLoaded] = useState(assistant? true: false);
    const [showDeleteAssistant,setShowDeleteAssistant] = useState(false);
    const navigate = useNavigate();
    const [actionHistory, setActionHistory] = useState([]);
    const [reload, setReload] = useState(false);
    const deleteAssistant = async()=>{
        await axios.delete(`${BASE_URL}/teacher/assistant?id=${assistant.id}`,{withCredentials:true})
        .then((response)=>{
            navigate("/admin-home/admin-assistants");
        }).catch((error)=>{
            console.log(error);
            navigate("/");
        })
    }

    const navigateToAction = (action)=>{
        if(action.action.includes("درس")|| action.action.includes("أكواد")){
            navigate(`/admin-home/video-details/${action.location.split("|")[0]}`,{state:{courseId:action.location.split("|")[1]}});
        }
        else if(action.action.includes("مادة")){
            navigate(`/admin-home/`)
        }
        else if(action.action.includes("مجلد") || action.action.includes("وحدة")){
            navigate(`/admin-home/folder/${action.location.split("|")[0]}`,{state:{folderName:action.objectName,courseId:action.location.split("|")[1]}})
        }
        else if(action.action.includes("اختبار")){
            navigate(`/admin-home/preview-exam/${action.location.split("|")}`);
        }
    }

    const clearAccount = ()=>{
        axios.get(`${BASE_URL}/teacher/clean-account?assistantId=${assistant.id}`,{withCredentials:true})
        .then(response=>{
            setAssistant(response.data);
            setReload(!reload);
        }).catch(error=>{
            console.log(error);
        })
    }

    const fetchData = async()=>{
        if(admin === null || admin === undefined){
            await axios.get(`${BASE_URL}/teacher/get-admin-by-token`,{withCredentials:true})
            .then((response)=>{
                setAdmin(response.data);
            }).catch((error)=>{
                navigate("/")
                console.log(error);
            })
        }
    
            await axios.get(`${BASE_URL}/teacher/get-assistant?id=${id}`,{withCredentials:true})
            .then((response)=>{
                setAssistant(response.data);
                setLoaded(true);
            }).catch((error)=>{
                console.log(error);
                navigate("/admin-assistants",{state:{admin:admin}});
            })
        }

    const getHistory = ()=>{
        axios.get(`${BASE_URL}/teacher/history?assistantId=${id}`,{withCredentials:true})
        .then(response=>{
            setActionHistory(response.data);
        }).catch(error=>{
            console.log(error)
            navigate("/");
        })
    }

    const clearHistory = ()=>{
        axios.delete(`${BASE_URL}/teacher/assistant-history?assistantId=${id}`,{withCredentials:true})
        .then(response=>{
            setActionHistory([]);
        }).catch(error=>{
            console.log(error);
        })
    }

    useEffect(()=>{
        fetchData();
        getHistory();
        setActive("المساعدين");
        
    },[reload]);

    return (
        <div>
        {loaded && (
            <div>
                <div className="admin-assistant-page-container">
                    <div className="left-side">
                        
                    </div>
                    <div className="right-side">
                        <label style={{width:"20%"}}>الاسم</label>
                        <input className="input-admin-assistant-page" type="text"
                        dir="rtl"
                        lang="ar"
                        value={assistant.name}
                        readOnly/>
                        <label>البريد الالكتروني</label>
                        <input className="input-admin-assistant-page"
                        type="text"
                        value={assistant.email}
                        readOnly/>

                        <label > مجموع الحساب</label>
                        <input className="input-admin-assistant-page" type="text"
                        value={assistant.totalFunds}
                        readOnly/>

                        <label > المستحق</label>
                        <input className="input-admin-assistant-page" type="text"
                        value={assistant.currentFunds}
                        readOnly/>
                       <div className="assistant-page-buttons">
                            <button className="delete-button" onClick={()=>{setShowDeleteAssistant(true)}}>حذف</button>
                            <button className="clear-account" onClick={clearAccount}>تصفية الاكواد</button>
                        </div>
                    </div>
                </div>

                { showDeleteAssistant && (
                    <div className="overlay">
                <div className="delete-admin-confirmation">
                    <h3>هل تريد بالفعل حذف هذا المساعد؟</h3>
                    <div className="add-assistant-form-buttons-div">
                        <button onClick={deleteAssistant} >نعم</button>
                        <button onClick={() => setShowDeleteAssistant(false)}>لا</button>
                    </div>
                </div>
                </div>
            )}
            </div>
        )}

        {(actionHistory!== null&&loaded) &&(
            <div className="action-history-div">
                <h2>سجل النشاطات</h2>
                <table>
                    <thead>
                        <tr>
                            <th>التاريخ</th>
                            <th>الوقت</th>
                            <th>الاسم</th>
                            <th>المساعد</th>
                            <th>الحدث</th>
                        </tr>
                    </thead>
                    <tbody>
                        {actionHistory.map(action=>{
                            console.log(action);
                        return (
                            <tr onClick={()=>{navigateToAction(action)}}>
                                <td>{action.date.split("T")[0]}</td>
                                <td>{action.date.split("T")[1]}</td>
                                <td>{action.objectName}</td>
                                <td>{action.assistantName}</td>
                                <td>{action.action}</td>
                            </tr>
                        )})}
                    </tbody>
                </table>
                <button className="clear-table" onClick={clearHistory}>مسح السجل</button>
            </div>
        )}

        

        </div>
    );
}